import * as React from 'react'

interface Config {
  enabled: boolean
  ref: any
}

interface AutofocusProps {
  enabled?: boolean
  children: React.ReactElement
}

export const Autofocus = React.forwardRef<HTMLElement, AutofocusProps>(
  ({ children, enabled = true, ...props }, ref) => {
    const childRef = (children as React.ComponentProps<any>).ref
    const scope = React.createRef<HTMLElement>()

    useAutofocus({ ref: scope, enabled })
    useSharedRef({ ref: scope, refs: [ref, childRef] })

    return children && React.cloneElement(children, { ...props, ref: scope })
  }
)

export const useAutofocus = ({ enabled = true, ref }: Config) =>
  React.useLayoutEffect(() => {
    enabled && ref && ref.current && ref.current.focus()
  }, [ref.current])

interface SharedRefConfig {
  ref: React.RefObject<HTMLElement>
  refs: React.MutableRefObject<HTMLElement>[]
}

// ==========
// SHARED REF
// ==========
// TODO: Move to own hook

const useSharedRef = ({ ref, refs }: SharedRefConfig) => {
  React.useLayoutEffect(() => {
    refs.forEach(
      (reference: React.MutableRefObject<HTMLElement | null> | Function) => {
        if (reference) {
          if (typeof reference === 'function') {
            reference
            reference(ref.current)
          } else {
            reference.current = ref.current
          }
        }
      }
    )
  }, [ref])
}
